import React, { useEffect, useMemo, useState } from "react";
import "./../Styling/RequestLeaveNew.css";
import {
  getTeamDetails,
  getLeaveBalances,
  applyLeave,
} from "../Api/RequestLeaveApi";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";

const RequestLeaveNew = () => {
  const { user } = useAuth();

  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [leaveBalances, setLeaveBalances] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");

  const [loading, setLoading] = useState(false);

  const [leaveData, setLeaveData] = useState({
    fromDate: "",
    toDate: "",
    fromHalf: "First Half",
    toHalf: "Second Half",
    leaveType: "",
    note: "",
    daysRequested: 0,
  });

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
  try {
    setLoading(true);

    const response = await getTeamDetails(
      user?.userId,
      user?.organisationId
    );

    if (response?.success) {
      const employees = response?.data || [];

      setTeamMembers(employees);

      // ✅ Auto select if only one employee
      if (employees.length === 1) {
        const employee = employees[0];

        setSelectedEmployee(employee.ResourceId);

        // ✅ Automatically fetch leave balances
        const leaveResponse = await getLeaveBalances(
          employee.ResourceId,
          user?.organisationId
        );

        if (leaveResponse?.success) {
          setLeaveBalances(leaveResponse?.data || []);
        }
      }
    }
  } catch (error) {
    console.error("Error fetching team details", error);
  } finally {
    setLoading(false);
  }
};

  const handleEmployeeChange = async (e) => {
    const resourceId = e.target.value;

    setSelectedEmployee(resourceId);

    try {
      const response = await getLeaveBalances(
        resourceId,
        user?.organisationId
      );

      if (response?.success) {
        setLeaveBalances(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching leave balances", error);
    }
  };

  const calculateLeaveDuration = (
    startDate,
    endDate,
    startHalf,
    endHalf
  ) => {
    if (!startDate || !endDate) return 0;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end - start;

    if (diffTime < 0) return 0;

    let totalDays = diffTime / (1000 * 60 * 60 * 24) + 1;

    if (startHalf === "Second Half") {
      totalDays -= 0.5;
    }

    if (endHalf === "First Half") {
      totalDays -= 0.5;
    }

    return totalDays;
  };

  useEffect(() => {
    const duration = calculateLeaveDuration(
      leaveData.fromDate,
      leaveData.toDate,
      leaveData.fromHalf,
      leaveData.toHalf
    );

    setLeaveData((prev) => ({
      ...prev,
      daysRequested: duration,
    }));
  }, [
    leaveData.fromDate,
    leaveData.toDate,
    leaveData.fromHalf,
    leaveData.toHalf,
  ]);

  const selectedLeave = useMemo(() => {
    return leaveBalances.find(
      (item) => item.LeaveTypeId === selectedLeaveType
    );
  }, [selectedLeaveType, leaveBalances]);
const selectedEmployeeData = teamMembers.find(
  (item) => item.ResourceId === selectedEmployee
);
  const handleSubmit = async () => {
    try {
      if (!selectedEmployee) {
        toast.error("Please select employee");
        return;
      }

      if (!leaveData.fromDate || !leaveData.toDate) {
        toast.error("Please select leave dates");
        return;
      }

      if (!selectedLeaveType) {
        toast.error("Please select leave type");
        return;
      }

      const leavePayload = {
  object: "Request Leave",
  activity: "Create",

  OrganisationId: user?.organisationId?.toString(),

  // ✅ SEND Mav_UserID HERE
  UserId:
    selectedEmployeeData?.Mav_UserID?.toString(),

  ResourceId:
    selectedEmployee ||
    user?.resourceId ||
    user?.userId?.toString(),

  CompanyCode: user?.companyCode?.toString(),

  StartLeaveDate: new Date(leaveData.fromDate),

  EndLeaveDate: new Date(leaveData.toDate),

  LeaveDuration: leaveData.daysRequested,

  LeaveType: selectedLeaveType,

  LeavePolicyId: user?.leavePolicyId,

  startHalf: leaveData.fromHalf,

  endHalf: leaveData.toHalf,

  Note: leaveData.note || "Leave application",
};

      const response = await applyLeave(leavePayload);
      console.log("Apply Leave Response:", response?.data);
      if (response?.success) {
        toast.success("Leave applied successfully");

        setLeaveData({
          fromDate: "",
          toDate: "",
          fromHalf: "First Half",
          toHalf: "Second Half",
          leaveType: "",
          note: "",
          daysRequested: 0,
        });

        setSelectedLeaveType("");
      } else {
        toast.error(response?.message || "Failed to apply leave");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="requestLeave-container">
      <div className="requestLeave-headerCard">
        <div>
          <div className="requestLeave-titleRow">
            <h1 className="requestLeave-title">Request Leave</h1>

            <span className="requestLeave-badge">
              Employee Self Service
            </span>
          </div>

          <p className="requestLeave-subtitle">
            Apply leave request with complete leave balance visibility
          </p>
        </div>

        <div className="requestLeave-actionButtons">
          <button className="requestLeave-outlineBtn">
            SAVE DRAFT
          </button>

          <button
            className="requestLeave-primaryBtn"
            onClick={handleSubmit}
          >
            APPLY LEAVE
          </button>
        </div>
      </div>

      <div className="requestLeave-mainCard">
        <div className="requestLeave-sectionHeader">
          <div className="requestLeave-iconBox">📄</div>

          <div>
            <h2>Leave Application Details</h2>

            <p>
              Enter leave information and select leave type
            </p>
          </div>
        </div>

        <div className="requestLeave-formSection">
          <div className="requestLeave-sectionTitle">
            PRIMARY DETAILS
          </div>

          <div className="requestLeave-grid requestLeave-grid4">
            <div className="requestLeave-field">
              <label>Apply For *</label>

              <select
                value={selectedEmployee}
                onChange={handleEmployeeChange}
              >
                <option value="">Select Employee</option>

                {teamMembers?.map((member) => (
                  <option
                    key={member.ResourceId}
                    value={member.ResourceId}
                  >
                    {member.Resource_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="requestLeave-field">
              <label>Start Leave Date *</label>

              <input
                type="date"
                value={leaveData.fromDate}
                onChange={(e) =>
                  setLeaveData({
                    ...leaveData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>

            <div className="requestLeave-field">
              <label>End Leave Date *</label>

              <input
                type="date"
                value={leaveData.toDate}
                onChange={(e) =>
                  setLeaveData({
                    ...leaveData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>

            <div className="requestLeave-field">
              <label>Leave Duration</label>

              <input
                type="text"
                value={`${leaveData.daysRequested} Day(s)`}
                readOnly
              />
            </div>
          </div>

          <div className="requestLeave-sectionTitle requestLeave-marginTop">
            HALF DAY CONFIGURATION
          </div>

          <div className="requestLeave-grid requestLeave-grid2">
            <div className="requestLeave-field">
              <label>Start Half</label>

              <select
                value={leaveData.fromHalf}
                onChange={(e) =>
                  setLeaveData({
                    ...leaveData,
                    fromHalf: e.target.value,
                  })
                }
              >
                <option value="First Half">First Half</option>
                <option value="Second Half">
                  Second Half
                </option>
              </select>
            </div>

            <div className="requestLeave-field">
              <label>End Half</label>

              <select
                value={leaveData.toHalf}
                onChange={(e) =>
                  setLeaveData({
                    ...leaveData,
                    toHalf: e.target.value,
                  })
                }
              >
                <option value="First Half">First Half</option>
                <option value="Second Half">
                  Second Half
                </option>
              </select>
            </div>
          </div>

          <div className="requestLeave-sectionTitle requestLeave-marginTop">
            LEAVE BALANCES
          </div>

          <div className="requestLeave-leaveGrid">
            {leaveBalances?.map((leave) => (
              <div
                key={leave.LeaveTypeId}
                className={`requestLeave-leaveTile ${
                  leave.CanApply === 0
                    ? "requestLeave-disabledTile"
                    : ""
                } ${
                  selectedLeaveType === leave.LeaveTypeId
                    ? "requestLeave-selectedTile"
                    : ""
                }`}
                onClick={() => {
                  if (leave.CanApply === 1) {
                    setSelectedLeaveType(leave.LeaveTypeId);

                    setLeaveData({
                      ...leaveData,
                      leaveType: leave.LeaveTypeId,
                    });
                  }
                }}
              >
                <div className="requestLeave-leaveName">
                  {leave.LeaveDescription}
                </div>

                <div className="requestLeave-balance">
                  {leave.LeaveBalance}
                </div>

                <div className="requestLeave-balanceText">
                  Balance
                </div>

                {leave.CanApply === 0 && (
                  <div className="requestLeave-notAllowed">
                    Cannot Apply
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="requestLeave-grid requestLeave-grid2 requestLeave-marginTop">
            <div className="requestLeave-field">
              <label>Selected Leave Type</label>

              <input
                type="text"
                value={
                  selectedLeave?.LeaveDescription || ""
                }
                readOnly
              />
            </div>

            <div className="requestLeave-field">
              <label>Leave Type ID</label>

              <input
                type="text"
                value={selectedLeaveType}
                readOnly
              />
            </div>
          </div>

          <div className="requestLeave-field requestLeave-marginTop">
            <label>Remarks</label>

            <textarea
              rows="4"
              placeholder="Enter remarks"
              value={leaveData.note}
              onChange={(e) =>
                setLeaveData({
                  ...leaveData,
                  note: e.target.value,
                })
              }
            />
          </div>

          <div className="requestLeave-bottomBtn">
            <button
              className="requestLeave-submitBtn"
              onClick={handleSubmit}
            >
              SUBMIT LEAVE REQUEST
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestLeaveNew;